export class CtaAnimation {
	id: number;
	animation_type: string;
	animation_url: string;
	animation_custom_url?: string;
	name: string;

	constructor(obj?: any) {
		this.id = (obj && obj.id) || 0;
		this.animation_type = (obj && obj.animation_type) || '';
		this.animation_url = (obj && obj.animation_url) || null;
		this.animation_custom_url = (obj && obj.animation_custom_url) || '';
		this.name = (obj && obj.name) || 'Lightning';
	}
}
